function d(e, r) {
  for (var t = -1, i = e == null ? 0 : e.length, u = 0, l = []; ++t < i; ) {
    var n = e[t];
    r(n, t, e) && (l[u++] = n);
  }
  return l;
}
var f = d;
export {
  f as default
};
//# sourceMappingURL=_arrayFilter.js.map
